@if (this.readonly()) {
<span
  (click)="this.copyToClipboard(this.value())"
  class="readonly py-2"
  pTooltip="SkillID kopieren: {{this.value()}}"
  tooltipPosition="top"
  i18n-pTooltip="@@copy-skill-id-tooltip"
><i class="text-muted  ps-1 ">{{this.value()}}</i></span>
}

@if (!this.readonly()) {
<input
  pInputText
  maxlength="20"
  style="max-width: 250px;background-color: #eee !important;"
  type="text"
  [ngClass]="{'filled': this.value().trim() !== ''}"
  [ngModel]="this.value()" (ngModelChange)="change($event)"
  (ngModelChange)="change($event)"
  [ngModelOptions]="{updateOn: 'blur'}"
  placeholder="SkillID"
>
}